 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_FRONTCOVER from '@/components/00_FrontCover'
 import LOVE_1 from '@/components/love_1'
 import A1_FRONTMATTER from '@/components/01_Frontmatter'
 import A2_DEDICATION from '@/components/02_Dedication'
 import A3_TITLEPAGE from '@/components/03_TitlePage'
 import A4_COPYRIGHT from '@/components/04_Copyright'
 import A5_DEDICATION1 from '@/components/05_Dedication1'
 import A6_DEDICATION2 from '@/components/06_Dedication2'
 import A7_CONTENTS from '@/components/07_Contents'
 import A7A_INTRODUCTION from '@/components/07a_Introduction'
 import A8_PROLOGUE from '@/components/08_Prologue'
 import A9_PART1 from '@/components/09_Part1'
 import A0_BOOK1 from '@/components/10_Book1'
 import A1_PART2 from '@/components/11_Part2'
 import A2_BOOK2 from '@/components/12_Book2'
 import A3_PART3 from '@/components/13_Part3'
 import A4_BOOK3 from '@/components/14_Book3'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/07_Contents",
 			"name" : "07_Contents",
 			"component" : A7_CONTENTS
 		},
 		{
 			"path" : "/07a_Introduction",
 			"name" : "07a_Introduction",
 			"component" : A7A_INTRODUCTION
 		},
 		{
 			"path" : "/08_Prologue",
 			"name" : "08_Prologue",
 			"component" : A8_PROLOGUE
 		},
 		{
 			"path" : "/09_Part1",
 			"name" : "09_Part1",
 			"component" : A9_PART1
 		},
 		{
 			"path" : "/10_Book1",
 			"name" : "10_Book1",
 			"component" : A0_BOOK1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js